<template>
  <div v-if="!showResponse" class="container">
    <h2>Restablece tu contraseña</h2>
    <p class="description">Introduzca la dirección de correo electrónico asociado a su cuenta de H2O.</p>
    <form class="mt-15" @submit.prevent="enviarMail">
      <InputText id="mail" placeholder="Correo electrónico" v-model="email" />
      <Button class="mt-35" type="button" text="Volver" classtype="back" @click="goToLogin" />
      <Button class="mt-35" type="submit" text="Enviar" classtype="primary" />
    </form>
    <hr class="mt-35" />
    <h3 class="mt-35">¿Has cambiado tu dirección de e-mail ?</h3>
    <p class="description-w">
      Si ya no utilizas la dirección de correo electrónico asociado a tu cuenta de H2O, ponte en contacto con
      <a id="link" target="_blank" href="https://www.h2ocomplejodeportivo.com/contacto/">atención al cliente</a> para
      recuperar el acceso.
    </p>
  </div>
  <Response
    v-else
    :success="responseSuccess"
    :title="responseTitle"
    :message="responseMessage"
    buttonText="Ver mis pases"
    :goToPage="DASHBOARD"
    showButton=""
  >
    <hr class="mt-35" />
    <p class="mt-35">¿No has recibido el correo electrónico?</p>
    <p class="description-w">
      Por favor, ponte en contacto con atención al cliente para que te ayuden con tu problema de acceso.
    </p></Response
  >
</template>
<script setup>
import { ref } from "vue"
import { goToLogin, OK } from "@/helpers"
import Button from "@/components/Button"
import { useAuthStore } from "@/store"
import InputText from "../components/InputText.vue"
import Response from "../components/Response.vue"

const email = ref("")
const authStore = useAuthStore()
const showResponse = ref(false)
const responseSuccess = ref(false)
const responseTitle = ref("")
const responseMessage = ref("")

const enviarMail = () => {
  authStore.sendRecoveryPass(email.value).then((response) => {
    if (response.result == OK) {
      responseTitle.value = "¡Correo electrónico enviado!"
      responseMessage.value =
        "En breve recibirás un correo de H2O con un enlace que te permitirá actualizar tu contraseña. Recuerda revisar en la carpeta SPAM."
      responseSuccess.value = true
    } else {
      responseTitle.value = "Error"
      responseMessage.value = response.message
      responseSuccess.value = false
    }
    showResponse.value = true
  })
}
</script>
<style>
#link {
  text-decoration: underline;
}
</style>
